import passportAPI from "@/api/passport";
import types from "../types";
import { baseURL } from "@/api/http-common";

// initial state
const state = {
  ids: [],
  entities: [],
};

const getPassports = (state) => state.ids.map((id) => state.entities[id]);

// getters
const getters = {
  [types.getters.passports]: getPassports,
  [types.getters.passport]: (state) => (passportID) =>
    state.entities[passportID],
  [types.getters.passportByContactID]: (state) => (contactID) => {
    const passport = Object.values(state.entities).find(
      (passport) => passport.contactID === contactID,
    );
    // console.log("passport:", passport)
    return passport;
  },
};

// actions
const actions = {
  [types.actions.updatePassportField](
    { commit },
    { passportID, fieldName, value },
  ) {
    commit(types.mutations.updatePassportField, {
      passportID,
      fieldName,
      value,
    });
  },
  [types.actions.updatePassportsRemote](
    { commit },
    { passports, showLoader = true },
  ) {
    const changedPassports = passports.filter((passport) => passport.isDirty);
    if (!changedPassports.length) {
      return Promise.resolve();
    }

    showLoader && commit(types.mutations.setIsLoading, { isLoading: true });

    return passportAPI
      .updatePassports(passports)
      .then((res) => {
        commit(types.mutations.resetContactsDirtyFlag);
        return res;
      })
      .finally(() => {
        showLoader &&
          commit(types.mutations.setIsLoading, { isLoading: false });
      });
  },
};

// mutations
const mutations = {
  [types.mutations.setPassports](state, passports) {
    state.ids = passports.map((passport) => passport.passportID);
    state.entities = passports.reduce((accumulate, passport) => {
      if (passport.file && passport.file.url) {
        passport.file.url = `${baseURL}/${passport.file.url}`;
      }

      accumulate[passport.passportID] = passport;
      return accumulate;
    }, {});
  },
  [types.mutations.updatePassportField](
    state,
    { passportID, fieldName, value },
  ) {
    state.entities[passportID][fieldName] = value;
    state.entities[passportID].isDirty = true;
  },
  [types.mutations.updatePassportEntity](state, { passport }) {
    if (passport.file && passport.file.url) {
      passport.file.url = `${baseURL}/${passport.file.url}`;
    }

    state.entities[passport.passportID] = passport;
  },
  [types.mutations.resetPassportsDirtyFlag](state) {
    getPassports(state).forEach((entity) => (entity.isDirty = false));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/passport.js